import styled from 'styled-components'
import { Button } from '../../styles/Buttons'

export const FacebookButton = styled(Button)`
  border: 1px solid #000000;
  background: transparent;
  border-radius: 7.6px;
  font-size: 16px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;

  &:active {
    background: ${props => props.theme.colors.primaryContrast};
  }

  svg {
    font-size: 25px;
  }

  div {
    width: 50%;
    text-align: center;
    font-size: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-all;
  }
`
